import { createContext, createRef, useContext } from 'react';
export const MentionContext = createContext({
    editorContainerRef: createRef(),
    getMentionSuggestions: () => Promise.resolve([])
});
export const MentionProvider = MentionContext.Provider;
export function useMentionContext() {
    return useContext(MentionContext);
}
